<template>
  <div>
    <b-navbar toggleable="lg" type="dark" fixed="top" class="invesnow-navbar">
      <template v-if="!check">
        <div class="row">
          <div class="col-6">
            <b-navbar-brand to="/">
              <img
                src="@/assets/img/invesnow-logo-blue.svg"
                class="invesnow-logo"
                alt="invesnow-logo"
              />
            </b-navbar-brand>
          </div>
          <div class="col-6 text-right">
            <b-button-group>
              <b-button
                size="sm"
                :to="{ path: '/' }"
                class="
                  btn-secondary
                  px-3
                  py-2
                  ml-3
                  mr-2
                  d-inline-block d-lg-none d-md-none
                "
                >Masuk</b-button
              >
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            </b-button-group>
          </div>
        </div>
      </template>

      <template v-else>
        <b-navbar-brand to="/">
          <img
            src="@/assets/img/invesnow-logo-blue.svg"
            class="invesnow-logo"
            alt="invesnow-logo"
          />
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      </template>

      <template v-if="!check">
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav>
              <!-- <b-nav-item href="https://invesnow.id" exact active-class="nav-active"
                >Home</b-nav-item
              > -->
              <b-nav-item
                :href="`${frontendLink}/promo`"
                exact
                active-class="nav-active"
                >Promo</b-nav-item
              >
              <b-nav-item
                :to="{ path: '/reksadana' }"
                exact
                active-class="nav-active"
                >Reksa Dana</b-nav-item
              >
              <b-nav-item
                :href="`${frontendLink}/artikel`"
                exact
                active-class="nav-active"
                >Artikel</b-nav-item
              >
            </b-navbar-nav>
          </b-navbar-nav>

          <b-button
            size="sm"
            :to="{ path: '/' }"
            class="
              btn-secondary
              py-2
              px-4
              d-none d-lg-inline-block d-md-inline-block
            "
            >Masuk</b-button
          >
        </b-collapse>
      </template>

      <template v-else>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav>
              <!-- <b-nav-item href="https://invesnow.id" exact active-class="nav-active"
                >Home</b-nav-item
              > -->
              <b-nav-item
                :href="`${frontendLink}/promo`"
                exact
                active-class="nav-active"
                >Promo</b-nav-item
              >
              <b-nav-item
                :to="{ path: '/reksadana' }"
                exact
                active-class="nav-active"
                >Reksa Dana</b-nav-item
              >
              <b-nav-item
                :to="{ path: '/portfolio' }"
                exact
                active-class="nav-active"
                >Portfolio</b-nav-item
              >
              <b-nav-item
                :to="{ path: '/orders' }"
                exact
                active-class="nav-active"
                >Transaksi</b-nav-item
              >
              <b-nav-item
                :href="`${frontendLink}/artikel`"
                exact
                active-class="nav-active"
                >Artikel</b-nav-item
              >
            </b-navbar-nav>
          </b-navbar-nav>

          <b-dropdown
            size="lg"
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <b-icon class="mx-1 text-muted" icon="bell" width="20"></b-icon>
            </template>
            <b-dropdown-item href="#">Belum ada Notifikasi</b-dropdown-item>
          </b-dropdown>
          <div v-if="user.individual != null">
            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
              text="Left align"
            >
              <template #button-content>
                <b-avatar
                  :src="
                    'https://ui-avatars.com/api/?background=EB321E&color=fff&name=' +
                    user.individual.email
                  "
                  size="2rem"
                ></b-avatar>
              </template>
              <b-dropdown-item to="/profile">Your profile</b-dropdown-item>
              <b-dropdown-item to="/setting">Setting</b-dropdown-item>
              <b-dropdown-item href="#" @click.prevent="logout"
                >Sign out</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <div v-else>
            <b-dropdown
              size="lg"
              right
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <b-avatar
                  :src="
                    'https://ui-avatars.com/api/?background=EB321E&color=fff&name=' +
                    user.institutional.company_name
                  "
                  size="2rem"
                ></b-avatar>
              </template>
              <b-dropdown-item to="/profile">Your profile</b-dropdown-item>
              <b-dropdown-item to="/setting">Setting</b-dropdown-item>
              <b-dropdown-item href="#" @click.prevent="logout"
                >Sign out</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </b-collapse>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "HomeHeader",
  props: {
    msg: String,
  },
  data() {
    return {
      frontendLink: process.env.VUE_APP_ROOT_FRONTEND,
    };
  },
  computed: {
    ...mapGetters({
      check: "auth/check",
      user: "auth/user",
    }),
  },
  mounted() {},
  methods: {
    ...mapActions({
      signout: "auth/signout",
    }),
    async logout() {
      await this.signout();
      window.location.href = "/";
      // this.$router.replace("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.invesnow-navbar {
  display: flex;
  flex-direction: row;
  padding: 15px 32px 15px 32px;
  height: 70px;
  background: white;
  box-shadow: 0px 1px 2px rgba(107, 114, 128, 0.06),
    0px 1px 3px rgba(107, 114, 128, 0.1);
  z-index: 99;
}

.invesnow-logo {
  width: 140px;
}

.nav-active {
  background: url("~@/assets/img/header/active-nav.svg");
  background-repeat: no-repeat;
  background-position: top center;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;

  color: #111827 !important;
  padding: 8px 16px 8px 16px;
  border-radius: 6px;
}

.navbar-dark .navbar-nav .nav-link {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;

  color: #6b7280;
  font-family: $inter;
  margin-right: 28px;
  padding: 8px 16px 8px 16px;
}
.navbar-dark .navbar-toggler {
  color: $primaryColor !important;
  background-color: $primaryColor !important;
  border-color: $primaryColor !important;
}

.navbar-collapse {
  background: white;
  padding: 8px;
}

.nav-item a {
  margin-right: 14px !important;
}

.dropdown-item:focus {
  background-color: $primaryColor !important;
}

.dropdown-item:active {
  background-color: $primaryColor !important;
}

@media only screen and (max-width: 768px) {
  .invesnow-logo {
    width: 100px;
  }
}
</style>